export default {
  Confirm: 'Bevestigen',
  Cancel: 'Annuleren',
  'The minimum time length is xxxs!': 'De minimale tijdsduur is {{num}}s!',
  'The maximum time length is 50s!': 'De maximale tijdsduur is 50s!',
  'Online service, no download required': 'Online service, geen download vereist',
  'Add up to 20MB file': 'Voeg tot 20MB bestand toe',
  'Support common formats': 'Ondersteunt gangbare formaten',
  'Best for general editing requirements': 'Het beste voor algemene bewerkingsbehoeften',
  '0 second wait': '0 seconden wachttijd',
  'No size limits': 'Geen groottebeperkingen',
  'Support 1000+ formats': 'Ondersteunt 1000+ formaten',
  'Stable processing': 'Stabiele verwerking',
  'Get access to HitPaw Toolkit!': 'Krijg toegang tot de HitPaw Toolkit!',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    'Ondersteunt knippen, bijsnijden & roteren, aanpassen, versnellen, muziek toevoegen, stop motion, enz.',
  'The easiest video editing software for beginners':
    'De gemakkelijkste videobewerkingssoftware voor beginners',
  'Remove watermark from videos and images in simple clicks':
    "Verwijder watermerk van video's en afbeeldingen met eenvoudige muisklikken",
  'TRY IT FREE': 'PROBEER HET GRATIS',
  'BUY NOW': 'NU KOPEN',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    'Analyse succesvol! Uw bestand is groter dan 100MB en kan niet worden bewerkt door HitPaw Online, alstublieft ',
  'download the video': 'download de video ',
  'and then use HitPaw Toolkit to proceed.': 'en gebruik daarna HitPaw Toolkit om verder te gaan.',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'Knip 10 video fragmenten hooguit. Krijg HitPaw Toolkit voor meer functies.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'De bestandsgrootte mag niet groter zijn dan 20MB. Krijg HitPaw Toolkit voor meer functies.',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    'De minimale tijdsduur is 1s! Krijg HitPaw Toolkit voor meer functies.',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    "Voeg hooguit x-video's toe. Krijg HitPaw Toolkit voor meer functies.",
  'This format is not supported currently.': 'Dit formaat wordt momenteel niet ondersteund.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'Dit formaat wordt momenteel niet ondersteund. Krijg HitPaw Toolkit voor meer functies.',
  'Processing failed. Get HitPaw Toolkit for stable processing.': 'Mislukt om video te genereren!',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.': 'Mislukt te laden!',
  'Are you sure you want to delete it?': 'Weet u zeker dat u het wilt verwijderen?',
  'Failed to extract the audio!': 'Het lukt niet om de audio uit te pakken!',
  'Coming Soon': 'Binnenkort',
  'Learn more': 'Leer meer',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    'Voeg tot 2 bestanden toe. Krijg HitPaw Toolkit voor meer functies.',
  Download: 'Downloaden',
  'Try Again': 'Probeer opnieuw',
  Failed: 'Mislukt',
  'Get Started': 'Beginnen',
  Start: 'Start',
  End: 'Einde',
  Export: 'Exporteren',
  'Your audio is ready!': 'Uw audio is klaar!',
  'Download Audio': 'Audio downloaden',
  YES: 'JA',
  'Export Failed': 'Exporteren mislukt',
  'Error occurs, the file cannot be added':
    'Er treedt een fout op, het bestand kan niet worden toegevoegd',
  'Support merging audio files at most':
    'Ondersteunt het samenvoegen van maximaal {{num}} audiobestanden',
  'Are you sure you want to delete this task?': 'Weet u zeker dat u deze taak wilt verwijderen?',
  Processing: 'Verwerken',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    'Vergeet niet je bestand te downloaden, het wordt na 24 uur verwijderd.',
  Uploading: 'Uploaden',
  'Go Edit': 'Ga naar bewerk',
  'Generate Files Successfully!': 'Bestanden met succes genereren!',
  'Your order is being paid...': 'Je bestelling wordt betaald',
  'Not yet': 'Nog niet',
  'Payment completed': 'Ja',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download Without Watermark',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
}
